import React from 'react';
import styled from 'styled-components';

import { colors, Heading, InternalLink, Text, media, Button } from '../ui-components';

import CONTENT from '../static-content/redirect-notice.json';

import redirectImage from '../images/redirectImage.png';

/**
 * @component Redirect
 * 
 * @prop {function} onDismiss
 * @prop {string} origin
 */
export const Redirect = ({ onDismiss, origin }) => {
  const type1 = false;

  const handleDismiss = () => {
    localStorage.setItem('displayRedirect', 'false');
    onDismiss();
  };

  return (
    <RedirectFullBackground>
      <RedirectContentContainer type1={type1}>
        <RedirectContent>
          <RedirectImage src={redirectImage} alt={'Welcome to Credera!'} />
          <>
            <Heading level={4}>{origin ? CONTENT[origin]?.header : 'Welcome to Credera!'}</Heading>
            <RedirectSubtitle size={'medium'}>{CONTENT.subtitle}</RedirectSubtitle>
          </>
          {type1 && (
            <ContinueToSiteButtonWrapper onClick={handleDismiss}>
              <InternalLink withArrow>Continue to site</InternalLink>
            </ContinueToSiteButtonWrapper>
          )}
          {!type1 && (
            <>
              <ContinueToSiteButton onClick={handleDismiss}>Continue to site</ContinueToSiteButton>
              <RedirectInternalLink withArrow to={'/'} onClick={handleDismiss}>
                Visit Home Page
              </RedirectInternalLink>
            </>
          )}
        </RedirectContent>
      </RedirectContentContainer>
    </RedirectFullBackground>
  );
};

const RedirectFullBackground = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: 999;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RedirectContentContainer = styled.div`
  width: 880px;
  height: ${({ type1 }) => (type1 ? `704px;` : `781px`)};
  background: ${colors.sandBeige};
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: ${media.mediumTop}) {
    width: 600px;
    height: ${({ type1 }) => (type1 ? `615px;` : `700px`)};
  }

  @media screen and (max-width: ${media.mediumBottom}) {
    justify-content: flex-start;
    width: 319px;
    height: ${({ type1 }) => (type1 ? `526px;` : `619px`)};
    padding: 32px 20px;
  }
`;

const RedirectContent = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  gap: 28px;

  @media screen and (max-width: ${media.mediumTop}) {
    width: 400px;
  }

  @media screen and (max-width: ${media.mediumBottom}) {
    gap: 12px;
    width: 279px;
  }
`;

const RedirectSubtitle = styled(Text)`
  margin-top: -16px;
  text-align: center;

  @media screen and (max-width: ${media.mediumBottom}) {
    margin-top: 0px;
    margin-bottom: 16px;
  }
`;

const RedirectImage = styled.img`
  height: 400px;
  width: 400px;
  margin: 0px;

  @media screen and (max-width: ${media.mediumTop}) {
    height: 340px;
    width: 340px;
  }

  @media screen and (max-width: ${media.mediumBottom}) {
    height: 280px;
    width: 280px;
  }
`;

const RedirectInternalLink = styled(InternalLink)`
  font-size: 14px;
`;

const ContinueToSiteButtonWrapper = styled.button``;

const ContinueToSiteButton = styled(Button)`
  @media screen and (max-width: ${media.mediumBottom}) {
    margin-bottom: 16px;
  }
`;
